"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getInvoiceInfo = getInvoiceInfo;
exports.getInvoiceList = getInvoiceList;
exports.invoiceExportBase = invoiceExportBase;
exports.invoiceExportSummary = invoiceExportSummary;
exports.invoiceImportBase = invoiceImportBase;
exports.invoiceImportSummary = invoiceImportSummary;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

/**
 * 发票列表
 * @param params
 */
function getInvoiceList(params) {
  return (0, _request.default)({
    url: '/admin/invoice/list',
    method: 'get',
    params: params
  });
}

/**
 * 发票详情
 * @param invoiceNo
 * @param params
 */
function getInvoiceInfo(invoiceNo, params) {
  return (0, _request.default)({
    url: "/admin/invoice/info/".concat(invoiceNo),
    method: 'get',
    params: params
  });
}

/**
 * 导入发票基础信息
 * @param data
 */
function invoiceImportBase(data) {
  return (0, _request.default)({
    url: "/admin/invoice/import/base",
    method: 'post',
    data: data
  });
}

/**
 * 导出发票基础信息
 * @param params
 */
function invoiceExportBase(params) {
  return (0, _request.default)({
    url: "/admin/invoice/export/base",
    method: 'get',
    params: params
  });
}

/**
 * 导入汇总工表单
 * @param data
 */
function invoiceImportSummary(data) {
  return (0, _request.default)({
    url: "/admin/invoice/import/summary",
    method: 'post',
    data: data
  });
}

/**
 * 导出汇总工表单
 * @param params
 */
function invoiceExportSummary(params) {
  return (0, _request.default)({
    url: "/admin/invoice/export/summary",
    method: 'get',
    params: params
  });
}